import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function Analytics() {
  const { settings } = useSettings();

  useEffect(() => {
    const gaId = settings.google_analytics_id;
    if (gaId && !document.getElementById("ga-gtag-script")) {
      const script = document.createElement("script");
      script.id = "ga-gtag-script";
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
      document.head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", gaId);
    }

    const pixelId = settings.meta_pixel_id;
    if (pixelId && !window.fbq) {
      const n = (window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      const t = document.createElement("script");
      t.id = "meta-pixel-script";
      t.async = true;
      t.src = "https://connect.facebook.net/en_US/fbevents.js";
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(t, s);
      window.fbq("init", pixelId);
      window.fbq("track", "PageView");
    }
  }, [settings.google_analytics_id, settings.meta_pixel_id]);

  return null;
}
